/**
 * Hook de la sesión. Separado del provider por `react-refresh`: un módulo que
 * exporta componentes no debe exportar otra cosa (§2.3 del blueprint).
 */

import { useContext } from 'react';

import { ContextoSesion, type ValorSesion } from './contextoSesion';

export function useSesion(): ValorSesion {
  const valor = useContext(ContextoSesion);
  if (!valor) throw new Error('useSesion se usó fuera de <SesionProvider>.');
  return valor;
}
